// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lOIn","title":"Header_title__2afns","side":"Header_side__cJQFV"};